<script>
import appConfig from "@/app.config";
import axios from "axios";
import Swal from "sweetalert2";
import { ref } from "vue";
import moment from "moment";

export default {
  page: {
    title: "Absensi Peserta / Instruktur",
    meta: [{ name: "description", content: appConfig.description }],
  },
  data() {
    return {
      id_pembelajaran: this.$route.params.idPembelajaran,

      no_surat: null,
      kode: null,
      judul: null,
      dasar_pelaksanaan: null,
      strategi: null,
      durasi_he: null,
      durasi_jp: null,
      tanggal_mulai: null,
      tanggal_selesai: null,
      learning_type: null,
      angkatan: null,
      pratikum: null,
      pic_pnt: null,
      pic_pte: null,

      tgl_hari_ini: moment(ref(new Date())).format("YYYY-MM-DD"),
      configuration: [],
      nip: null,
      role_absensi: "",
      lock_absensi: false,
    };
  },
  components: {},
  mounted() {
    let self = this;
    Swal.fire({
      title: '<i class="fas fa-spinner fa-spin"></i>',
      text: "Loading...",
      showConfirmButton: false,
      allowOutsideClick: false,
    });

    var config_login = {
      method: "get",
      url: process.env.VUE_APP_BACKEND_URL_VERSION + "referensi/konfig-login",
      headers: {
        Accept: "application/json",
      },
    };
    axios(config_login)
      .then(function (response) {
        var response_data = response.data;
        var response_data_fix = response_data.data;
        if (response_data.meta.code == 200) {
          self.configuration = response_data_fix.referensi;
        } else {
          Swal.close();
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: response_data_fix.data.message,
          });
        }
      })
      .catch(function (error) {
        console.log(error);
      });

    // get data pembelajaran
    var config = {
      method: "get",
      url: process.env.VUE_APP_BACKEND_URL_VERSION + "referensi/pembelajaran",
      params: {
        id_pembelajaran: self.id_pembelajaran,
      },
      headers: {
        Accept: "application/json",
      },
    };
    axios(config)
      .then(function (response) {
        var response_data = response.data;
        if (response_data.meta.code == 200) {
          var data_pembelajaran = response_data.data.data_pembelajaran;
          self.no_surat = data_pembelajaran.pbl_nomor_surat;
          self.kode = data_pembelajaran.pbl_kode;
          self.judul = data_pembelajaran.pbl_judul;
          self.dasar_pelaksanaan = data_pembelajaran.pbl_dasar_pelaksanaan;
          self.strategi = data_pembelajaran.pbl_strategi;
          self.durasi_he = data_pembelajaran.pbl_durasi_he;
          self.durasi_jp = data_pembelajaran.pbl_durasi_jp;
          self.tanggal_mulai = data_pembelajaran.pbl_tgl_mulai;
          self.tanggal_selesai = data_pembelajaran.pbl_tgl_selesai;
          self.learning_type = data_pembelajaran.pbl_lt_name;
          self.angkatan = data_pembelajaran.pbl_angkatan;
          self.pratikum = data_pembelajaran.pbl_pratikum;

          if (
            self.tgl_hari_ini >= data_pembelajaran.pbl_tgl_mulai &&
            self.tgl_hari_ini <= data_pembelajaran.pbl_tgl_selesai
          ) {
            self.lock_absensi = false;
          } else {
            self.lock_absensi = true;
          }

          Swal.close();
        } else {
          Swal.close();
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: response_data.meta.message,
          });
        }
      })
      .catch(function (error) {
        console.log(error);
        Swal.close();
      });
  },
  methods: {
    validationForm() {
      if (this.nip == null) {
        Swal.fire({
          icon: "warning",
          title: "Perhatian...",
          text: "Mohon Masukkan NIP Peserta!",
        });
        return;
      } else if(this.role_absensi == ""){
        Swal.fire({
          icon: "warning",
          title: "Perhatian...",
          text: "Mohon Pilih Role Absensi!",
        });
        return;
      } else {
        this.storeData();
      }
    },
    storeData() {
      let self = this;
      Swal.fire({
        title: '<i class="fas fa-spinner fa-spin"></i>',
        text: "Loading...",
        showConfirmButton: false,
      });

      var config_store_data = {
        method: "post",
        url:
          process.env.VUE_APP_BACKEND_URL_VERSION +
          "referensi/pembelajaran-absensi-store",
        data: {
          id_pembelajaran: self.id_pembelajaran,
          nip: self.nip,
          tgl_hari_ini: self.tgl_hari_ini,
          role_absensi: self.role_absensi
        },
        headers: {
          Accept: "application/json",
          Authorization: "Bearer " + localStorage.access_token,
        },
      };
      axios(config_store_data)
        .then(function (response) {
          Swal.fire({
            icon: response.data.data.type,
            title: response.data.data.title,
            text: response.data.data.message,
            timer: 3000,
            timerProgressBar: true,
            showCancelButton: false,
            showConfirmButton: false,
          }).then((result) => {
            /* Read more about handling dismissals below */
            if (result.dismiss === Swal.DismissReason.timer) {
              Swal.close();
            }
          });
        })
        .catch(function (error) {
          Swal.close();
          self.axiosCatchError = error.response.data.data;
        });
    },
  },
};
</script>
<template>
  <div class="account-pages my-0 pt-sm-0">
    <div class="container">
      <div class="row">
        <div class="col-lg-12">
          <div class="text-center mb-4 text-muted">
            <router-link to="/" class="d-block auth-logo">
              <img
                :src="configuration.LOGO_FULL_DARK"
                v-bind:alt="configuration.APPLICATION_FULL_NAME"
                height="100"
                class="auth-logo-dark mx-auto"
              />
              <img
                :src="configuration.LOGO_FULL_LIGHT"
                v-bind:alt="configuration.APPLICATION_FULL_NAME"
                height="100"
                class="auth-logo-light mx-auto"
              />
            </router-link>
            <h4 class="mt-3">{{ configuration.APPLICATION_FULL_NAME }}</h4>
            <h5>Absensi Peserta / Instruktur Pembelajaran</h5>
          </div>
        </div>
      </div>

      <div class="row justify-content-center">
        <div class="col-md-12 col-lg-12 col-xl-12">
          <div v-if="lock_absensi == true">
            <div class="card">
              <div class="card-body">
                <div class="p-0">
                  <div class="text-center">
                    <div class="avatar-md mx-auto">
                      <div class="avatar-title rounded-circle bg-light">
                        <i class="bx bx-list-check h1 mb-0 text-primary"></i>
                      </div>
                    </div>
                    <div class="p-2 mt-3">
                      <div class="row">
                        <div class="col-12 text-center">
                          <h4>
                            Absensi Pembelajaran di luar Tanggal Pelaksanaan.
                          </h4>
                          <hr />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-else>
            <b-form class="p-2" @submit.prevent="validationForm">
              <div class="card">
                <div class="card-body">
                  <div class="p-0">
                    <div class="text-center">
                      <div class="avatar-md mx-auto">
                        <div class="avatar-title rounded-circle bg-light">
                          <i class="bx bx-list-check h1 mb-0 text-primary"></i>
                        </div>
                      </div>
                      <div class="p-2 mt-2">
                        <div class="row">
                          <div class="col-12">
                            <p>Informasi Pembelajaran :</p>
                          </div>
                          <div class="col-12 mt-2 mb-2">
                            <div class="row">
                              <div class="col-6">
                                <div class="col-12">
                                  <h5 class="font-size-14 mb-1">
                                    <span class="text-dark"
                                      >Kode Pembelajaran</span
                                    >
                                  </h5>
                                  <p class="text-muted mb-0">{{ kode }}</p>
                                  <hr />
                                </div>

                                <div class="col-12">
                                  <h5 class="font-size-14 mb-1">
                                    <span class="text-dark"
                                      >Judul Pembelajaran</span
                                    >
                                  </h5>
                                  <p class="text-muted mb-0">{{ judul }}</p>
                                  <hr />
                                </div>
                                <div class="col-12">
                                  <h5 class="font-size-14 mb-1">
                                    <span class="text-dark">Strategi</span>
                                  </h5>
                                  <p class="text-muted mb-0">{{ strategi }}</p>
                                  <hr />
                                </div>
                                <div class="col-12">
                                  <h5 class="font-size-14 mb-1">
                                    <span class="text-dark"
                                      >Durasi Hari Efektif (HE)</span
                                    >
                                  </h5>
                                  <p class="text-muted mb-0">{{ durasi_he }}</p>
                                  <hr />
                                </div>
                                <div class="col-12">
                                  <h5 class="font-size-14 mb-1">
                                    <span class="text-dark"
                                      >Durasi Jam Pembelajaran (JP)</span
                                    >
                                  </h5>
                                  <p class="text-muted mb-0">{{ durasi_jp }}</p>
                                  <hr />
                                </div>
                              </div>
                              <div class="col-6">
                                <div class="row">
                                  <div class="col-12">
                                    <h5 class="font-size-14 mb-1">
                                      <span class="text-dark"
                                        >Dasar Pelaksanaan</span
                                      >
                                    </h5>
                                    <p class="text-muted mb-0">
                                      {{ dasar_pelaksanaan }}
                                    </p>
                                    <hr />
                                  </div>
                                  <div class="col-12">
                                    <h5 class="font-size-14 mb-1">
                                      <span class="text-dark"
                                        >Tipe Pembelajaran</span
                                      >
                                    </h5>
                                    <p class="text-muted mb-0">
                                      {{ learning_type }}
                                    </p>
                                    <hr />
                                  </div>
                                  <div class="col-12">
                                    <h5 class="font-size-14 mb-1">
                                      <span class="text-dark">Angkatan</span>
                                    </h5>
                                    <p class="text-muted mb-0">
                                      {{ angkatan }}
                                    </p>
                                    <hr />
                                  </div>
                                  <div class="col-12">
                                    <h5 class="font-size-14 mb-1">
                                      <span class="text-dark"
                                        >Tanggal Mulai</span
                                      >
                                    </h5>
                                    <p class="text-muted mb-0">
                                      {{ tanggal_mulai }}
                                    </p>
                                    <hr />
                                  </div>
                                  <div class="col-12">
                                    <h5 class="font-size-14 mb-1">
                                      <span class="text-dark"
                                        >Tanggal Selesai</span
                                      >
                                    </h5>
                                    <p class="text-muted mb-0">
                                      {{ tanggal_selesai }}
                                    </p>
                                    <hr />
                                  </div>
                                </div>
                              </div>
                              <div class="col-12">
                                <h5 class="font-size-14 mb-1">
                                  <span class="text-dark"
                                    >Tanggal Hari Ini</span
                                  >
                                </h5>
                                <p class="text-muted mb-0">
                                  {{ tgl_hari_ini }}
                                </p>
                                <hr />
                              </div>
                              <div class="col-12">
                                <p>
                                  Mohon pilih role anda apakah Peserta atau Instruktur lalu masukkan NIP anda untuk konfirmasi
                                  kehadiran absensi :
                                </p>
                              </div>
                              <div class="col-6">
                                <select id="role" required v-model="role_absensi" class="form-control">
                                <option value="">Pilih Role Absensi...</option>
                                <option value="1">Peserta</option>
                                <option value="2">Instruktur</option>
                                </select>
                              </div>
                              <div class="col-6">
                                <b-form-input
                                  id="nip"
                                  placeholder="Masukkan NIP..."
                                  type="text"
                                  v-model="nip"
                                  required
                                ></b-form-input>
                              </div>
                              <div class="col-12 mt-3">
                                <center>
                                  <b-button type="submit" variant="primary">
                                    <i class="fa fa-save"></i> Simpan Absensi
                                  </b-button>
                                </center>
                                <hr />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </b-form>
          </div>

          <div class="mt-2 text-center">
            <p>
              ©
              {{ new Date().getFullYear() }}
              {{ configuration.COPYRIGHT_COPORATION }}.
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
